"use client";

export default function Spinner({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      {...props}
      className={`animate-spin text-blue-600 w-6 h-6${
        className ? ` ${className}` : ""
      }`}
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="Loading"
    >
      <circle opacity=".25" cx="12" cy="12" r="10" />
      <path d="M4 12a8 8 0 018-8v4l3.536-3.536A8 8 0 014 12z" />
    </svg>
  );
}
